import {
  type DashboardActions,
  InternalMembersActions,
} from '@store/reducers/dashboard/actions'
import { GeneralErrorNotification } from '@storeOld/reducers/notification'
import { call, put } from 'redux-saga/effects'

import { NestClient } from '@/nest'

export function* cancelInvitation({
  payload: { id, workspaceId },
}: ReturnType<typeof DashboardActions.members.cancelInvitation>) {
  yield put(InternalMembersActions.remove({ id, workspaceId }))
  try {
    yield call(NestClient.membership.cancelInvitation, workspaceId, id)
  } catch (e) {
    console.error('Error while invitation cancel', e)
    yield put(GeneralErrorNotification)
  }
  yield put(InternalMembersActions.fetchList({ workspaceId }))
}
